/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ currency: NonNullable<unknown> }} Metapaidsuffix2Inputs */

const en_metapaidsuffix2 = /** @type {(inputs: Metapaidsuffix2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currency} paid`)
};

const pt_metapaidsuffix2 = /** @type {(inputs: Metapaidsuffix2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currency} pagos`)
};

/**
* | output |
* | --- |
* | "{currency} paid" |
*
* @param {Metapaidsuffix2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const metapaidsuffix2 = /** @type {((inputs: Metapaidsuffix2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metapaidsuffix2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metapaidsuffix2(inputs)
	return pt_metapaidsuffix2(inputs)
});
export { metapaidsuffix2 as "metaPaidSuffix" }